export default __webpack_public_path__ + "static/media/changestatus.cafa09ab.svg";